import { BookOpen, ImageAlt, Layout } from '@styled-icons/boxicons-regular';
import { Zap } from '@styled-icons/boxicons-solid';
import classNames from 'classnames';
import mixpanel from 'mixpanel-browser';
import Image from 'next/legacy/image';
import Link from 'next/link';
import { useContext, useEffect } from 'react';
import { ChatsCircle } from 'phosphor-react';
import { EVENT } from '../../analytics';
import OptionsContainer from '../../sharedComponents/Options';
import Popup from '../../sharedComponents/TextEditor/components/Popup';
import { CollectionTutorialDispatchContext } from '../CollectionTutorialPopup/context';
import { TutorialDispatchContext } from '../TutorialPopup/context';
import styles from './HelpPopup.module.css';
import { HelpPopupContext, HelpPopupDispatchContext } from './context';

declare let zE: any;
function HelpPopup() {
  const helpPopupOpen = useContext(HelpPopupContext);
  const sethelpPopupOpen = useContext(HelpPopupDispatchContext);
  const settutorialOpen = useContext(TutorialDispatchContext);
  const setcollectionTutorialOpen = useContext(CollectionTutorialDispatchContext);

  useEffect(() => {
    if (helpPopupOpen) {
      mixpanel.track(EVENT.OPENED_HELP_RESOURCES);
    }
  }, [helpPopupOpen]);

  return (
    <Popup
      width="auto"
      height="auto"
      open={helpPopupOpen}
      setopen={sethelpPopupOpen}
      className="p-0"
    >
      <div className={classNames(styles.container, 'p-6')}>
        <div className="is-size-5 with-text-color mb-5 has-text-weight-medium">
          How can we help?
        </div>
        <Link
          href="https://typedream.com/docs"
          target="_blank"
          rel="noreferrer"
          legacyBehavior
          onClick={() =>
            mixpanel.track(EVENT.USED_HELP_RESOURCES, { help_resources: 'documentation' })
          }
        >
          <OptionsContainer
            selected={false}
            className="is-align-items-center is-justify-content-flex-start mb-2"
          >
            <div className={styles.icon}>
              <BookOpen size={20} className="with-accent-text-color" />
            </div>
            <div className="is-flex-direction-column is-align-items-center is-justify-content-flex-start">
              <div className="is-size-6 with-text-color">Help, Guides & Documentation &rarr;</div>
            </div>
          </OptionsContainer>
        </Link>

        <OptionsContainer
          selected={false}
          onClick={() => {
            zE('messenger', 'open');
            mixpanel.track(EVENT.USED_HELP_RESOURCES, { help_resources: 'get_support' });
          }}
          className="is-align-items-center is-justify-content-flex-start mb-2"
        >
          <div className={styles.icon}>
            <ChatsCircle size={20} className="with-accent-text-color" />
          </div>
          <div className="is-flex-direction-column is-align-items-center is-justify-content-flex-start">
            <div className="is-size-6 with-text-color">Get Support &rarr;</div>
          </div>
        </OptionsContainer>

        <div className="is-size-6 with-text-color mb-2 mt-5">Resources</div>

        <div className="is-flex is-align-items-center is-justify-content-flex-start mb-2">
          <Link
            href="https://typedream.com/assets"
            target="_blank"
            rel="noreferrer"
            onClick={() => mixpanel.track(EVENT.USED_HELP_RESOURCES, { help_resources: 'assets' })}
          >
            <OptionsContainer
              selected={false}
              className="is-align-items-center is-justify-content-flex-start mr-2"
            >
              <div className={styles.icon}>
                <ImageAlt size={20} className="with-accent-text-color" />
              </div>
              <div className="is-flex-direction-column is-align-items-center is-justify-content-flex-start">
                <div className="is-size-6 with-text-color">Assets &rarr;</div>
              </div>
            </OptionsContainer>
          </Link>

          <Link
            href="https://typedream.com/templates"
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              mixpanel.track(EVENT.USED_HELP_RESOURCES, { help_resources: 'templates' })
            }
          >
            <OptionsContainer
              selected={false}
              className="is-align-items-center is-justify-content-flex-start mr-2"
            >
              <div className={styles.icon}>
                <Layout size={20} className="with-accent-text-color" />
              </div>
              <div className="is-flex-direction-column is-align-items-center is-justify-content-flex-start">
                <div className="is-size-6 with-text-color">Templates &rarr;</div>
              </div>
            </OptionsContainer>
          </Link>

          <Link
            href="https://typedream.com/docs/integration"
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              mixpanel.track(EVENT.USED_HELP_RESOURCES, { help_resources: 'integrations' })
            }
          >
            <OptionsContainer
              selected={false}
              className="is-align-items-center is-justify-content-flex-start mr-2"
            >
              <div className={styles.icon}>
                <Zap size={20} className="with-accent-text-color" />
              </div>
              <div className="is-flex-direction-column is-align-items-center is-justify-content-flex-start">
                <div className="is-size-6 with-text-color">Integrations &rarr;</div>
              </div>
            </OptionsContainer>
          </Link>
        </div>

        <div className="is-size-6 with-text-color mb-2 mt-5">Tutorials</div>
        <div className="is-flex is-align-items-center is-justify-content-flex-start mb-2">
          <OptionsContainer
            selected={false}
            className="is-align-items-center is-justify-content-flex-start mr-2"
            onClick={() => {
              settutorialOpen(true);
              mixpanel.track(EVENT.USED_HELP_RESOURCES, { help_resources: 'getting_started' });
            }}
          >
            <div className="is-flex-direction-column is-align-items-center is-justify-content-flex-start">
              <Image
                src="/images/gettingstarted-thumbnail.png"
                width={150}
                height={100}
                objectFit="contain"
              />
              <div className="is-small-subtitle-size with-text-color">Getting Started</div>
            </div>
          </OptionsContainer>
          <OptionsContainer
            selected={false}
            className="is-align-items-center is-justify-content-flex-start mr-2"
            onClick={() => {
              setcollectionTutorialOpen(true);
              mixpanel.track(EVENT.USED_HELP_RESOURCES, { help_resources: 'cms' });
            }}
          >
            <div className="is-flex-direction-column is-align-items-center is-justify-content-flex-start">
              <Image src="/images/cms-thumbnail.png" width={150} height={100} objectFit="contain" />
              <div className="is-small-subtitle-size with-text-color">Collections (CMS)</div>
            </div>
          </OptionsContainer>
        </div>
      </div>
    </Popup>
  );
}

export default HelpPopup;
